import { tradeRouteServerSideProps } from '@/components/Homepage/homepageProps.server';

export { default } from '@/components/Homepage/HomepagePage';

export const getServerSideProps = tradeRouteServerSideProps('swap');
